<template>
  <v-main :class="$style.main">
    <router-view></router-view>
  </v-main>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
.main {
  min-height: 300px;
}
</style>
